import { put, select } from "redux-saga/effects";
import axios from "../../axios";
import * as actionsIndex from "../actions/index";
import { API_Q_ACTIVTS_V4, API_GAME } from "../../constants/api";
import { filtersModel } from "../../models/filters";
import { checkIsOlderThanLast4Hours } from "../../helpers";
import { nextDecode, nextEncode } from "../../helpers/utilityHelpers";

/**
 * Routes [STEPS]
 * Step 03: This saga will operate and redirect to a aciton (setActivities or fetchActivitiesFailed)
 * Let's say it redirect to setActivities(response.data)
 * > Go to: ../action/activities.js
 */
const getFilters = (state) => state.filters;
// Saga generators
export function* initFetchActivitiesSaga(action) {
  const _filters = yield select(getFilters);

  try {
    const lastUpdate = localStorage.getItem("last_activities_update");
    const lastActivities = localStorage.getItem("last_acts"); //"last_activities"
    let activities = null;
    if (
      // false && // if want to fetch a new dada each time
      lastActivities &&
      lastUpdate &&
      checkIsOlderThanLast4Hours(lastUpdate)
    ) {
      try {
        activities = nextDecode(lastActivities);
        activities = JSON.parse(activities);
      } catch (error) {}
    } else {
      const response = yield axios.get(API_Q_ACTIVTS_V4);
      // activities = updateImageGames(response.data);
      activities = updateImageGames(response.data);
      yield localStorage.setItem("last_activities_update", new Date());
      try {
        localStorage.setItem(
          "last_acts",
          nextEncode(JSON.stringify(activities))
        );
      } catch (error) {}
    }
    yield put(actionsIndex.setActivities(activities));

    const filters = getFiltersHandler(activities);
    const newFilters = {
      ...filters,
      active: { ...filters.active, ..._filters["filters"].active },
      totalActive: _filters["filters"].totalActive,
    };
    yield put(actionsIndex.setFiltersActivities(newFilters));
  } catch (error) {
    yield put(actionsIndex.fetchActivitiesFailed(error));
  }
}

const updateImageGames = (activities) => {
  const newActivities = activities.map((acitivty) => {
    const cover =
      acitivty.type === "Audio"
        ? API_GAME + "/audio/" + acitivty.images["cover"]
        : API_GAME + "/" + acitivty.slug + "/jogo_imagem_.jpg";
    const thumb =
      acitivty.type === "Audio"
        ? API_GAME + "/audio/" + acitivty.images["thumb"]
        : API_GAME + "/" + acitivty.slug + "/jogo_imagem_.jpg";
    acitivty.images["cover"] = cover;
    acitivty.images["thumb"] = thumb;
    if (acitivty.type === "Audio") {
      const devUrl = API_GAME + "/audio/" + acitivty.activity_urls["dev"];
      acitivty["activity_urls"]["dev"] = devUrl;
      acitivty["activity_urls"]["prod"] = devUrl;

      const gabaritoUrl =
        API_GAME + "/audio/gabaritos/" + acitivty.url_answers["dev"];
      acitivty["url_answers"]["dev"] = gabaritoUrl;
      acitivty["url_answers"]["prod"] = gabaritoUrl;
    }

    return acitivty;
  });
  return newActivities;
};

const ageRangeFilter = (age) => {
  switch (age) {
    case "3": {
      return "3-4";
    }
    case "5": {
      return "5-6";
    }
    case "7": {
      return "7-9";
    }
    case "8": {
      return "8-9";
    }
    case "9": {
      return "9-99";
    }
  }
};

const getFiltersHandler = (activities) => {
  const _filter = filtersModel;

  activities.forEach((game) => {
    if (game.difficulties && _filter.all.difficulties) {
      Object.keys(game.difficulties).forEach((key) => {
        if (key) {
          _filter.all.difficulties[key] = key;
        }
      });
    }

    if (game.others_abilities_ids) {
      game.others_abilities_ids.forEach((ability) => {
        _filter.all.ability_fono[ability] = [ability];
        _filter.all.ability_paid[ability] = [ability];
        _filter.all.ability_free[ability] = [ability];
      });
    }

    if (game.age_range && game.age_range.age_min && _filter.all.min_age) {
      let age = ageRangeFilter(game.age_range.age_min);
      if (age) {
        _filter.all.min_age[game.age_range.age_min] = age;
      }
    }

    if (game.language && _filter.all.language.indexOf(game.language) === -1) {
      _filter.all.language.push(game.language);
    }
  });

  return _filter;
};
